export default __webpack_public_path__ + "static/spot-longevity__heart-metabolic-free-01-938106bc5a0266cc8cc9c3b868b66562.jpg";